import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyWeaveTruelarkLogo = lazy(() => import('./svg-components/weave-truelark-logo'));

const WeaveTruelarkLogo = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyWeaveTruelarkLogo {...rest} />
  </Suspense>
);

export default WeaveTruelarkLogo;
